import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { RouterProvider } from '@tanstack/react-router'
import { router } from './router'

const rootElement = document.getElementById('root')!

// Prerendered pages (scripts/prerender.ts) bake static article HTML into #root
// so crawlers see content before JS runs — so #root being non-empty is normal
// and must not skip mounting. createRoot().render() replaces that static
// content with the app on first commit.
const root = createRoot(rootElement)
root.render(
  <StrictMode>
    <RouterProvider router={router} />
  </StrictMode>
)
